import React, { useState, useMemo } from 'react';
import Grid from '../../components/Grid/Grid';

function Originals({ data }) {
  const [inventory, setInventory] = useState(null);

  const filterData = (data) => {
    const inventoryFromData = data
      .map((d) =>
        d.artwork.map((dd) => ({
          ...dd,
          artist: d.name,
          photo: d.photo,
          artistId: d.id,
        }))
      )
      .flat()
      .filter((ff) => ff.type.includes('Original'));
    setInventory(inventoryFromData);
  };

  useMemo(() => filterData(data), [data]);

  if (inventory)
    return (
      <div className='home'>
        <h1 className='center'>
          Curated Art: Original Artwork
        </h1>
        {inventory && <Grid items={inventory} />}
      </div>
    );
  return 'No results';
}

export default Originals;
